import React, { useEffect, useState } from "react";
import Flatpickr from "react-flatpickr";
import moment from 'moment';
import { createAxiosInstance } from "../utils/AxiosInstance";
import { useConfig } from "../utils/ConfigContext";
import monthSelectPlugin from "flatpickr/dist/plugins/monthSelect";

import "flatpickr/dist/themes/material_blue.css";
import "flatpickr/dist/plugins/monthSelect/style.css";

const CenterOpdComparisonReport = () => {
    const { API_BASE_URL } = useConfig(); // ✅ from context
    const AxiosInstance = createAxiosInstance(API_BASE_URL);

    const [groups, setGroups] = useState([]);
    const [comparisonData, setComparisonData] = useState([]);
    const [loading, setLoading] = useState(false);

    const [currentMonth, setCurrentMonth] = useState(moment().format('YYYY-MM'));
    const [lastMonth, setLastMonth] = useState(moment().subtract(1, "month").format("YYYY-MM"));
    const [lastTwoMonth, setLastTwoMonth] = useState(moment().subtract(2, "month").format("YYYY-MM"));

    const [centerIds,setCenterIds] = useState([]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!centerIds || centerIds.length === 0) {
            alert("Please select at least one center group");
            return;
        }
        setLoading(true);
        try {
            const payload = {
                centerIds: centerIds,
                current_month: currentMonth+ '-01',
                last_month: lastMonth+ '-01',
                last_two_month: lastTwoMonth+ '-01'
            };
            const res = await AxiosInstance.post('/centers_opd_comparison', payload);
            console.log("API Response:", res.data);
            if (res.data.status && res.data.data) {
                setComparisonData(res.data.data);
            } else {
                setComparisonData([]);
                alert("No data found for the selected criteria");
            }
        } catch (error) {
            console.error("Error submitting data:", error);
            alert("Error fetching comparison report");
            setComparisonData([]);
        } finally {
            setLoading(false);
        }
    };


    const getMonthOptions = () => ({
        plugins: [
            new monthSelectPlugin({
                shorthand: true,
                dateFormat: "Y-m",
                altFormat: "F Y",
            })
        ]
    });
    const formatYearMonth = (date) => {
        if (!date) return null;

        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");

        return `${year}-${month}`;
    };
    const formatMonth = (date) => {
        if (!date) return "";
        return moment(date).format("MMMM YYYY");
    }
    const myGroups = async(userId)=> {
        const res  = await AxiosInstance.get('/centergroups');
        setGroups( res.data.data || [] );
        //map group with their id
       

    }

    const handleChangeGroup = (group_id) => {
        if (!group_id || group_id === "0") {
            setCenterIds([]);
            return;
        }
        const selected_group = groups.find((group) => group.id == group_id);

        if (selected_group) {
            const selected_centers = selected_group.centers.map( (center)=> center.hm_id )
            setCenterIds(selected_centers);
           
        }
    }

    useEffect( ()=>{
        myGroups();
    },[]);

    return (
        <div className="card shadow-sm">
            <div className="card-body">

                <form onSubmit={handleSubmit}>

                    <div className="row g-3">
                        {/* groups */}
                        <div className="col-md-2">
                            <label className="form-label">Select Center Groups</label>
                            <select name="mygroups" id="mygroups" onChange={ (e)=> {handleChangeGroup(e.target.value)} } className="form-control">
                                <option value="0">Select Groups</option>
                               {groups.map( (group) => (
                                  <option key={group.id} value={group.id} >{group.name}</option>
                               ))}
                            </select>
                        </div>

                        {/* Current Month */}
                        <div className="col-md-2">
                            <label className="form-label">Current Month</label>
                            <Flatpickr
                                value={currentMonth}
                                onChange={(dates) => setCurrentMonth(formatYearMonth(dates[0]))}
                                options={getMonthOptions()}
                                className="form-control"
                                name="current_month"
                            />
                        </div>

                        {/* Last Month */}
                        <div className="col-md-2">
                            <label className="form-label">Last Month</label>
                            <Flatpickr
                                value={lastMonth}
                                onChange={(dates) => setLastMonth(formatYearMonth(dates[0]))}
                                options={getMonthOptions()}
                                className="form-control"
                                name="last_month"
                            />
                        </div>

                        {/* Two Months Ago */}
                        <div className="col-md-2">
                            <label className="form-label">Two Months Ago</label>
                            <Flatpickr
                                value={lastTwoMonth}
                                onChange={(dates) => setLastTwoMonth(formatYearMonth(dates[0]))}
                                options={getMonthOptions()}
                                className="form-control"
                                name="last_two_month"
                            />
                        </div>
                        <div className="col-md-2 d-flex align-items-end">
                            <button type="submit" className="btn btn-primary" disabled={loading}>
                                {loading ? (
                                    <>
                                        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                        Loading...
                                    </>
                                ) : (
                                    "Apply Filter"
                                )}
                            </button>

                        </div>

                    </div>



                </form>
                <div className="mt-10">
                    <table className="table table-sm table-bordered table-hover">
                        <thead className="table-primary">
                            <tr>
                                <th className="text-center" rowSpan={2}>Center Name</th>
                                <th className="text-center" colSpan={2}>{formatMonth(currentMonth)}</th>
                                <th className="text-center"colSpan={2}>{formatMonth(lastMonth)}</th>
                                <th className="text-center"colSpan={2}>{formatMonth(lastTwoMonth)}</th>
                            </tr>
                            <tr>
                                <th className="text-center">OPD</th>
                                <th className="text-center">Conversion</th>
                                <th className="text-center">OPD</th>
                                <th className="text-center">Conversion</th>
                                <th className="text-center">OPD</th>
                                <th className="text-center">Conversion</th>
                            </tr>
                        </thead>
                        <tbody>
                            {loading ? (
                                <tr>
                                    <td className="text-center" colSpan={7}>
                                        <div className="spinner-border" role="status">
                                            <span className="visually-hidden">Loading...</span>
                                        </div>
                                    </td>
                                </tr>
                            ) : comparisonData && comparisonData.length > 0 ? (
                                comparisonData.map((center) => (
                                    <tr key={center.centerId}>
                                        <td>{center.center_name}</td>
                                        <td className="text-center">{center.current_month?.opd || '-'}</td>
                                        <td className="text-center">{center.current_month?.conversion || '-'}</td>
                                        <td className="text-center">{center.last_month?.opd || '-'}</td>
                                        <td className="text-center">{center.last_month?.conversion || '-'}</td>
                                        <td className="text-center">{center.last_two_month?.opd || '-'}</td>
                                        <td className="text-center">{center.last_two_month?.conversion || '-'}</td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td className="text-center" colSpan={7}>No Data found</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>

            </div>
        </div>
    );
};

export default CenterOpdComparisonReport;